import React, { memo } from 'react';
import ListHeader from '../ListHeader';
import styles from './styles.module.scss';

var SelectedListHeader = function SelectedListHeader(_ref) {
  var count = _ref.count,
      label = _ref.label,
      actionButton = _ref.actionButton;
  return /*#__PURE__*/React.createElement(ListHeader, null, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("span", null, count, " ", label)), actionButton);
};

export default memo(SelectedListHeader);